import {State} from './reducer'

export const initialState: Omit<State, 'account'> = {
  showMinimumDepositRequiredPopup: false,
  showTransferNeededPopup: false,
  showPendingPopup: false,
}
